import types from "./types";

export function setOneTime() {
  return {
    type: types.SET_BILLING_TYPE,
    billingType: "one-time",
  };
}

export function setRecurring() {
  return {
    type: types.SET_BILLING_TYPE,
    billingType: "recurring",
  };
}

export function setOngoingPayments() {
  return {
    type: types.SET_PAYMENT_TYPE,
    paymentType: "ongoing",
  };
}

export function setPaymentInterval(interval) {
  return {
    type: types.SET_PAYMENT_INTERVAL,
    paymentInterval: interval,
  };
}

export function showAverageAmount() {
  return {
    type: types.TOGGLE_AVERAGE_AMOUNT,
    bool: true,
  };
}

export function hideAverageAmount() {
  return {
    type: types.TOGGLE_AVERAGE_AMOUNT,
    bool: false,
  };
}

export function setIsStripeSepaDebit(value) {
  return {
    type: types.IS_STRIPE_SEPA_DEBIT,
    isStripeSepaDebit: value,
  };
}
